
import BaseToggle from '@marketplace/components/shared/toggle/BaseToggle.vue'
import { NOT_PAID, PAID } from '@marketplace/config/payment.js'
import sortBy from 'lodash/sortBy'

export default {
    name: 'ModalPaymentDetails',

    components: {
        BaseToggle,
    },

    props: {
        paymentDetails: {
            type: Array,
            default: () => [],
        },
        invoices: {
            type: Array,
            default: () => [],
        },
        switchPaymentUrl: {
            type: String,
            default: '',
        },
        shouldToggleInvoice: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            NOT_PAID,
        }
    },

    computed: {
        paymentDetailsToTable() {
            if (!this.paymentDetails) {
                return
            }

            const payments = this.paymentDetails
                .filter((item) => item.externalStatus !== PAID)
                .map((item) => {
                    const amount = item.amount
                    const amountDue = item?.amountDue
                    const amountPaid = item?.amountPaid
                    const status = item?.externalStatus
                    const dueAt = item?.externalDueAt
                    const description = item?.description

                    const { reference, bankName, bankAccount, bankBic } =
                        item.externalPaymentDetails

                    return {
                        component: this.shouldWrapInToggle ? BaseToggle : 'div',
                        dueAt: dueAt ? this.$datetime.formatDate(dueAt) : null,
                        dueInDays: dueAt
                            ? this.$datetime.timeUntil(dueAt, 'days')
                            : null,
                        isOverDue: dueAt
                            ? this.$datetime.isDateExpired(dueAt)
                            : false,
                        description,
                        paymentData: {
                            status,
                            reference,
                            bankAccount,
                            bankName,
                            bankBic,
                            amount,
                            amountDue,
                            amountPaid,
                        },
                    }
                })

            return sortBy(payments, 'dueAt')
        },

        shouldWrapInToggle() {
            return this.paymentDetails?.length > 1
        },

        showIbanChangedNotice() {
            return !this.$datetime.isDateExpired('2026-07-12')
        },
    },

    methods: {
        invoiceToggleInitialState(index, reference = null) {
            return this.shouldToggleInvoice !== null && reference !== null
                ? this.shouldToggleInvoice === reference
                : index === 0
        },
    },
}
